<template>
  <div class="progress-wrap">
      <titleBar title="退费进度" @callback="goBack" :callback="true"></titleBar>
      <!-- <mt-header fixed title="退费进度" class="header-css">
        <mt-button icon="back" slot="left" @click="goBack"></mt-button>
      </mt-header> -->
      <div class="back-css"></div>
      <div class="progress-status">
        <div class="progress-bar">
            <!-- <component :is="mt-progress" :value="progressValue" :bar-height="4"></component> -->
            <mt-progress :value="progressValue" :bar-height="4"></mt-progress>
        </div>
        <div class="progress-css">
            <div class="success-css">
               <img :src="successIcon"/>
               <div class="suc-word">申请成功</div>
            </div>
            <div class="accept-css" v-show="acceptShow">
               <img :src="acceptIcon">
               <div class="ace-word">受理中</div>
            </div>
            <div class="reback-css" v-show="!acceptShow">
               <div class="refund-box">2</div>
               <div class="refund-word">受理中</div>
            </div>
             <div class="reback-css" v-show="refundStatus == 1">
               <div class="refund-box">3</div>
               <div class="refund-word">退费成功</div>
            </div>
            <div class="refund-css" v-show="refundStatus == 2">
               <img :src="acceptIcon">
               <div class="red-word">退费成功</div>
            </div>
            <div class="refund-css" v-show="refundStatus == 3">
               <img :src="failIcon">
               <div class="red-word">退费失败</div>
            </div>
        </div>
        <div class="progress-desc">
            -退款预计3-15个工作日到账-
        </div>
      </div>
      <div class="progress-detail">
          <div class="detail-title">
            <div class="title-icon"></div>
            <div class="title-name">退费详情</div>
          </div>
          <div class="detail-css">
            <div class="form-detail">
                <div class="title-name">银行卡号</div><div class="content">{{handleCardNum(cardNumber) || '--'}}</div>
            </div>
            <div class="form-detail">
                <div class="title-name">户名</div><div class="content">{{account || '--'}}</div>
            </div>
             <div class="form-detail">
                <div class="title-name">开户行</div><div class="content">{{bank || '--'}}</div>
            </div>
             <div class="form-detail">
                <div class="title-name">手机号码</div><div class="content">{{handlePhoneNum(contacts) || '--'}}</div>
            </div>
             <div class="form-detail">
                <div class="title-name">退费金额</div><div class="content-cash">{{amount|| '248'}}元</div>
            </div>
          </div>
      </div>
      <div class="common-question">
          <div class="detail-title">
            <div class="title-icon"></div>
            <div class="title-name">常见问题</div>
          </div>
          <div class="content-detal">
            <div class="question-title">Q1：银行卡（借记卡）号填错了怎么办？</div>
            <div class="question-content">
                可拨打客服电话：4000 100 180 咨询后续处理办法。
            </div>
          </div>
          <div class="content-detal">
            <div class="question-title">Q2：退费失败是什么原因？怎么办？</div>
            <div class="question-content">
                原因：银行卡（借记卡）号、户名或开户行信息填写错误、银行账户异常等问题都可能导致退费失败。<br>
                解决办法：用户核实以上信息及账户状态无误后，可点击退费进度页面下方的【重新申请】按钮重新申请。
            </div>
          </div>
          <div class="content-detal">
            <div class="question-title">Q3：退款几天能到账？</div>
            <div class="question-content">
                如提交的信息无误，退款一般会在3-15个工作日
                到账。具体到账时间与银行受理情况有关，请耐
                心等待。
            </div>
          </div>
          <div class="content-detal">
            <div class="question-title">Q4：其他问题</div>
            <div class="question-content">
                如有其他问题请联系客服。<br>
                客服电话：4000 100 180 <br>
                在线时间：周一至周日 08:00-22:00
            </div>
          </div>
      </div>
      <mt-button type='primary' class="refund-but" @click="handleReFundClickFun" v-show="isReFundShow">重新申请</mt-button>
  </div>
</template>

<script>
import titleBar from "@/components/common/titleBar.vue";
import utils from "@/assets/js/utils";
import ajax from "@/api/ajax";
import { Progress, Button } from 'mint-ui';
export default {
    name: "refundProgress",
    data() {
        return {
            successIcon: require('../../assets/svg/success.svg'),
            acceptIcon: require('../../assets/svg/accept.svg'),
            failIcon: require('../../assets/svg/failx.svg'),
            version: "",
            source: "",
            token: "",
            refundShow: false,
            acceptShow: true,
            refundStatus: 1,
            bank: '',
            cardNumber: '',
            contacts: '',
            account: '',
            amount: '',
            progressValue: 50,
            isReFundShow: false
        }
    },
    components: {
        titleBar,
        Progress,
        Button
    },
    mounted() {
        this.token = utils.getQueryString("token");
        this.version = utils.getQueryString("version");
        this.source = utils.getQueryString("source");
        this.handleGetProgress();
        this.$nextTick(() => {
            this.isProShow = true
            this.progressValue = 50
        })
    },
    methods: {
        // 银行卡号处理
        handleCardNum(value) {
            return '*********' + value.substr(-4)
        },
        // 手机号处理
        handlePhoneNum(value) {
            return value.substr(0, 3) + '****' + value.substr(-4)
        },
        // 返回页面
        goBack() {
            window.location.href = `hybird://method/exit`;
            // let timestamp = Date.parse(new Date());
            // this.$router.push(`/card/studyProgress?source=${this.source}&token=${this.token}&version=${this.version}&random=${timestamp}`);
        },
        // 获取进度
        handleGetProgress: async function() {
            let self = this;
            const [resp] = await ajax.all([
                ajax.get("/pay/return-money/get-progress-new", {
                    params: {
                        token: self.token,
                        version: self.version,
                        source: self.source
                    }
                })
            ]);
            if (resp.data.code == 99999) {
                this.data = resp.data.data;
                this.refundStatus = resp.data.data.refundStatus
                this.account = resp.data.data.account
                this.bank = resp.data.data.bank
                this.cardNumber = resp.data.data.cardNumber
                this.contacts = resp.data.data.contacts
                this.amount = resp.data.data.amount

                if (resp.data.data.refundStatus == 1) {
                    this.progressValue = 50
                } else if (resp.data.data.refundStatus == 2) {
                    this.progressValue = 100
                } else if (resp.data.data.refundStatus == 3) {
                    this.progressValue = 100
                    this.isReFundShow = true
                }
                utils.sendLog({
                    token: this.token,
                    version: this.version,
                    source: this.source,
                    extensionJson: {
                        refundStatus: this.refundStatus,
                    }
                }, 'hzxx3253');
            }
        },
        // 重新申请
        handleReFundClickFun() {
            utils.sendLog({
                token: this.token,
                version: this.version,
                source: this.source,
            }, 'hzxx3254');
            this.$router.push({ path: '/card/refund', query: { token: this.token, version: this.version, source: this.source }});
        }
    }
}
</script>

<style lang="scss" scoped>
.progress-wrap {
    margin-top: 0.88rem;
    background-color: #F6F6F6;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    position: relative;
    .header-css {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        height: .88rem;
        line-height: .88rem;
        font-size: .34rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background-color: #43A5F3;
        border: solid 1px red;
        z-index: 100;
    }
    .back-css {
        height: 2.72rem;
        width: 100%;
        background-color: #43A5F3;
    }
    .progress-status {
        position: absolute;
        top: .28rem;
        width: calc(100% - 0.8rem);
        height: 2.69rem;
        margin-top: 1.16rem;
        background-color: #ffffff;
        left: 50%;
        transform: translate(-50%);
        border-radius: 16px;
        .progress-bar {
            position: absolute;
            width: 4.36rem;
            left: 50%;
            top: .45rem;
            transform: translateX(-50%);
            z-index: -10;
        }
        .progress-css {
            height: 2rem;
            border-bottom: 1px dashed #e6e6e6;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: .48rem .6rem;
            img {
                width: .56rem;
            }
            .success-css {
               width: 1.12rem; 
               text-align: center;
               .suc-word {
                    height: .40rem;
                    font-size: .28rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #43A5F3;
                    line-height: .40rem;
                    margin-top: .08rem;
               }
            }
            .accept-css {
               width: 1.12rem; 
               text-align: center;
               .ace-word {
                    height: .40rem;
                    font-size: .28rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #43A5F3;
                    line-height: .40rem;
                    margin-top: .08rem;
               }
            }
            .refund-css {
               width: 1.12rem; 
               text-align: center;
               .red-word {
                    height: .40rem;
                    font-size: .28rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #43A5F3;
                    line-height: .40rem;
                    margin-top: .08rem;
               }
            }
            .reback-css {
                width: 1.12rem;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .refund-box {
                    width: .56rem;
                    height: .56rem;
                    border: 4px solid #e6e6e6;
                    border-radius: .28rem;
                    text-align: center;
                    font-size: .30rem;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #BEC0C2;
                    background: #ffffff;
                }
                .refund-word {
                    height: .40rem;
                    font-size: .28rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #BEC0C2;
                    line-height: .40rem;
                    margin-top: 0.08rem;
                }
            }
        }
        .progress-desc {
            width: 100%;
            height: .68rem;
            font-size: .26rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #BEC0C2;
            line-height: .68rem;
            text-align: center;
        }
    }
    .progress-detail {
        margin: 1.71rem auto 0 auto;
        width: calc(100% - .8rem);
        height: 4.36rem;
        background: #ffffff;
        border-radius: 14px;
        .detail-title {
            display: flex;
            flex-direction: row;
            padding-top: .48rem;
            .title-icon {
                width: .08rem;
                height: .42rem;
                background: #43A5F3;
                border-radius: 0 .06rem .06rem 0;
            }
            .title-name {
                margin-left: .28rem;
                height: .45rem;
                line-height: .45rem;
                font-size: .32rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
            }
        }
        .detail-css {
           padding: .25rem .36rem 0 .36rem;
           .form-detail {
               display: flex;
               flex-direction: row;
               .title-name {
                    width: 1.5rem;
                    font-size: .28rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #424243;
                    line-height: .54rem;
               }
               .content {
                    width: 100%;
                    font-size: .28rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #919294;
                    line-height: .54rem;
                    text-align: right;
               }
           }
           .content-cash {
               width: 100%;
               text-align: right;
               font-weight: 600;
           }
        }
    }
    .common-question {
        margin: .28rem auto 0 auto;
        width: calc(100% - .8rem);
        background: #ffffff;
        border-radius: 14px;
        height: 10.91rem;
        .detail-title {
            display: flex;
            flex-direction: row;
            padding-top: .48rem;
            .title-icon {
                width: .08rem;
                height: .42rem;
                background: #43A5F3;
                border-radius: 0 .06rem .06rem 0;
            }
            .title-name {
                margin-left: .28rem;
                height: .45rem;
                line-height: .45rem;
                font-size: .32rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
            }
        }
        .content-detal {
            padding: .29rem .36rem;
            .question-title {
                height: .40rem;
                font-size: .28rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #424243;
                line-height: .40rem;
            }
            .question-content {
                margin-top: .16rem;
                font-size: .28rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #919294;
                line-height: .40rem;
            }
        }
    }
    .refund-but {
        width: 6.70rem;
        height: .88rem;
        line-height: .88rem;
        display: block;
        background: #43A5F3;
        border-radius: .44rem;
        font-size: .36rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        margin: .48rem auto .37rem auto;
        cursor: pointer;
    }
}
</style>
